export default "__VITE_ASSET__DFe3cIqx__"